export default () => {

  function tooltipTpl(information) {
    let tpl = '';
    for (let k = 0; k < information.length; k += 1) {
      const address = information[k].address ?
        `<address class="info-window__item info-window__address">
          <svg width="12" height="12" viewBox="0 0 13 16" xmlns="http://www.w3.org/2000/svg"><path d="M6.5 0C2.91588 0 0 2.59944 0 5.79457C0 9.75982 5.81686 15.581 6.06452 15.8269C6.29714 16.0579 6.70328 16.0575 6.93548 15.8269C7.18314 15.581 13 9.75982 13 5.79457C12.9999 2.59944 10.0841 0 6.5 0ZM6.5 8.70998C4.69674 8.70998 3.22972 7.40213 3.22972 5.79457C3.22972 4.187 4.69678 2.87919 6.5 2.87919C8.30322 2.87919 9.77024 4.18704 9.77024 5.7946C9.77024 7.40217 8.30322 8.70998 6.5 8.70998Z" /></svg>
          ${information[k].address}
        </address>`
        : '';

      const email = information[k].email ?
        `<div class="info-window__item info-window__email">
          <svg width="12" height="12" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M10.6064 8.08208L16.0004 11.4921V4.52808L10.6064 8.08208Z" /><path d="M0 4.52808V11.4921L5.394 8.08208L0 4.52808Z" /><path d="M14.9998 2.5H0.999785C0.500785 2.5 0.104785 2.872 0.0297852 3.351L7.99978 8.602L15.9698 3.351C15.8948 2.872 15.4988 2.5 14.9998 2.5Z" /><path d="M9.68974 8.68606L8.27474 9.61806C8.19074 9.67306 8.09574 9.70006 7.99974 9.70006C7.90374 9.70006 7.80874 9.67306 7.72474 9.61806L6.30974 8.68506L0.0317383 12.6561C0.108738 13.1311 0.502738 13.5001 0.999738 13.5001H14.9997C15.4967 13.5001 15.8907 13.1311 15.9677 12.6561L9.68974 8.68606Z" /></svg>
          <a href="mailto:${information[k].email}">${information[k].email}</a>
        </div>` : '';

      const phonesList = information[k].phones.map((phone) => {
        const phoneLink = phone.replace(/\s+/g, '');
        return `<a href="tel:${phoneLink}" class="info-window__item info-window__phone">${phone}</a>`;
      }).join('');
      tpl += `<div class="info-window">
                <div class="info-window__holder">
                  <div class="info-window__item info-window__name">
                    <div class="info-window__img">
                      <img src="${information[k].img}" width="20" height="20" alt="${information[k].name}" title="${information[k].name}">
                    </div>
                    ${information[k].name}
                  </div>
                  ${address}
                  <div class="info-window__phones-wrap">
                    <svg width="12" height="12" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M15.9924 12.6271C16.0263 12.887 15.9471 13.113 15.7552 13.3051L13.5025 15.5423C13.4008 15.6553 13.2682 15.7514 13.1045 15.8304C12.9407 15.9095 12.7798 15.9604 12.6218 15.9829C12.6105 15.9829 12.5766 15.9858 12.5201 15.9915C12.4637 15.9971 12.3903 16 12.3 16C12.0853 16 11.7381 15.9633 11.2582 15.8898C10.7783 15.8163 10.1911 15.6355 9.4967 15.3474C8.80213 15.0593 8.01454 14.627 7.13378 14.0508C6.25303 13.4746 5.31576 12.6836 4.32206 11.6779C3.53162 10.8983 2.87668 10.1525 2.35724 9.44069C1.83781 8.7288 1.42 8.07061 1.10383 7.46609C0.787621 6.86157 0.550488 6.31355 0.392399 5.82202C0.23431 5.3305 0.127036 4.90677 0.0705753 4.55084C0.0141151 4.19491 -0.00846904 3.91525 0.00282301 3.71186C0.0141151 3.50847 0.0197611 3.39547 0.0197611 3.37288C0.0423452 3.21468 0.0931595 3.05367 0.172204 2.88983C0.251248 2.72598 0.347231 2.59322 0.460151 2.49152L2.71292 0.237288C2.87101 0.0790959 3.05168 0 3.25493 0C3.40173 0 3.53159 0.0423728 3.64451 0.127118C3.75743 0.211864 3.85341 0.316384 3.93246 0.440677L5.74483 3.88135C5.84646 4.06214 5.87469 4.25988 5.82952 4.47457C5.78436 4.68926 5.68837 4.87005 5.54158 5.01694L4.71161 5.84745C4.68903 5.87005 4.66926 5.90677 4.65233 5.95762C4.63539 6.00846 4.62692 6.05084 4.62692 6.08473C4.67209 6.32202 4.77372 6.59321 4.93181 6.89829C5.06731 7.16948 5.27621 7.49999 5.55851 7.88982C5.84082 8.27965 6.24168 8.72877 6.76112 9.23724C7.26926 9.75707 7.72094 10.161 8.11616 10.4492C8.5113 10.7372 8.84171 10.9491 9.10707 11.0847C9.37243 11.2203 9.57569 11.3022 9.71681 11.3304L9.92848 11.3728C9.95107 11.3728 9.98785 11.3643 10.0386 11.3474C10.0894 11.3304 10.1261 11.3107 10.1487 11.288L11.1142 10.305C11.3175 10.1242 11.5546 10.0338 11.8256 10.0338C12.0176 10.0338 12.17 10.0677 12.2829 10.1355H12.2998L15.5688 12.0677C15.8061 12.2147 15.9472 12.4011 15.9924 12.6271Z"/></svg>
                    <div class="info-window__phones-list">${phonesList}</div>
                  </div>
                  ${email}
                  <a href="${information[k].link}" target="_blank" rel="nofollow" class="info-window__show-map">${showOnMap}</a>
                </div>
              </div>`
    }
    return `<div class="info-window__list">${tpl}</div>`;
  }

  $('.contacts-nav__item').on('click', () => {
    $('.map-holder__aside-inner').html('');
    $('.map-holder__aside').show();
  })

  const { google } = window;
  const bounds = new google.maps.LatLngBounds();
  const infowindow = new google.maps.InfoWindow();
  const defaultZoom = 10;
  const JSONdate = new Date().toLocaleString().replace(/[^0-9]/g, '');
  // const JSONpath = `/map/locations.json?${JSONdate}`;
  const JSONpath = `../../API/locations.json?${JSONdate}`;
  const markers = [];
  let infoContent = [];
  const dataLink = document.querySelectorAll('.contacts-nav__location li');

  const request = new XMLHttpRequest();
  request.open('GET', JSONpath, true);
  let map;

  const openPopupFunction = (marker, i, data) => {
    google.maps.event.addListener(marker, 'click', (function name() {
      return function name2() {
        const information = data[i].info;
        infowindow.setContent(tooltipTpl(information));
        infowindow.open(map, marker);
        $('.info-window__item').each(function eachPopups() {
          if ($(this).height() === 0) {
            $(this).hide();
          }
        })
      }
    })(marker, i));
  }

  const showInfoList = (category, data) => {
    $('.map-holder__aside-inner').html('');
    if (Array.isArray(data)) {
      const information = [];
      for (let i = 0; i < data.length; i += 1) {
        if (data[i].categ === category) {
          information.push(data[i])
        }
      }
      $('.map-holder__aside-inner').append(tooltipTpl(information));
      $('.map-holder__aside').show();
    } else if (data.categ === category) {
      const information = data.info;
      $('.map-holder__aside-inner').append(tooltipTpl(information));
      $('.map-holder__aside').show();
    }
  }

  const clickOnTabItem = (hideMarkers, showMarkers) => {
    $('.contacts-nav__item').on('click', function clickOnTabItemHandler() {
      $('.contacts-nav__item').removeClass('active');
      $(this).addClass('active');
      const cat = $(this).data('value');
      const newArr = infoContent.filter(item => item.categ === cat)
      showInfoList(cat, newArr);
      hideMarkers(markers, cat);
      showMarkers(markers, cat);
      infowindow.close();
      $('.contacts-nav__location').val('all');
    })
  }

  const buildMap = (data) => {
    map = new google.maps.Map(document.getElementById('map'), {
      zoom: defaultZoom,
      // styles: mapStyles,
      scrollwheel: false,
      navigationControl: false,
      mapTypeControl: false,
      scaleControl: false,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
    });

    const iconSrc = {};
    // iconSrc.manager = 'front/dist/images/pin-red.png';
    // iconSrc.service = 'front/dist/images/pin-blue.png';
    // iconSrc.stock = 'front/dist/images/pin-green.png';
    iconSrc.manager = './images/pin-r.svg';
    iconSrc.service = './images/pin-b.svg';
    iconSrc.stock = './images/pin-g.svg';

    if (data.length) {
      for (let i = 0; i < data.length; i += 1) {
        const name = data[i].categ.split(',');
        const coordinate = data[i].coordinates.split(',');
        const coordinateX = coordinate[0];
        const coordinateY = coordinate[1];

        const marker = new google.maps.Marker({
          position: new google.maps.LatLng(coordinateX, coordinateY),
          map,
          icon: iconSrc[name]
        });
        marker.index = i;

        const showMarkers = (catSingle, category) => {
          if (data[i].categ === category) {
            marker.setVisible(true);
          }
        }

        const hideMarkers = (catSingle, category) => {
          if (data[i].categ !== category) {
            marker.setVisible(false);
          }
        }

        clickOnTabItem(hideMarkers, showMarkers, data[i])
        openPopupFunction(marker, i, data)
        markers.push(marker);
        bounds.extend(marker.position);
      }
    }

    google.maps.event.addListener(map, 'zoom_changed', () => {
      const zoomChangeBoundsListener =
        google.maps.event.addListener(map, 'bounds_changed', function setZoomMap() {
          if (this.getZoom() > 12 && this.initialZoom === true) {
            this.setZoom(9);
            this.initialZoom = false;
          }
          google.maps.event.removeListener(zoomChangeBoundsListener);
        });
    });
    map.initialZoom = true;
    map.fitBounds(bounds);
    map.panToBounds(bounds);
  };

  request.onload = () => {
    if (request.status >= 200 && request.status < 400) {
      const data = JSON.parse(request.responseText);
      const coordinats = [];

      for (const i in data) {
        const dataAll = data[i].addreses
        for (const j in dataAll) {
          coordinats.push(dataAll[j])
        }
      }

      coordinats.filter(item => {
        item.info.forEach(info => {
          infoContent.push(info)
        })
      })

      buildMap(coordinats);
      $('#manager').trigger('click');

      const startCoordinates = [];
      const information = [];

      for (let i = 0; i < coordinats.length; i += 1) {
        if (coordinats[i].categ === "manager") {
          startCoordinates.push(coordinats[i]);
          return startCoordinates;
        };
      }

      for (let i = 0; i < startCoordinates.length; i += 1) {
        information.push(startCoordinates[i].info);
        return information;
      }

    }
  }
  request.send();

  dataLink.forEach(dataLinkCurrent => {
    dataLinkCurrent.addEventListener('click', () => {
      console.log(54545);
      infoContent = [];
      const dataLinkCurrentValue = dataLinkCurrent.dataset.value;
      if (dataLinkCurrentValue) {
        request.open('GET', JSONpath, true);
        request.onload = () => {
          if (request.status >= 200 && request.status < 400) {
            const data = JSON.parse(request.responseText);
            const coordinats = [];
            const allCoordinats = [];

            for (const i in data) {
              const dataAllName = data[i].region;
              const dataAll = data[i].addreses;
              for (const j in dataAll) {
                if (dataAllName == dataLinkCurrentValue) {
                  coordinats.push(dataAll[j]);
                }
                if (dataLinkCurrentValue == 'all') {
                  coordinats.push(dataAll[j]);
                  allCoordinats.push(dataAll[j]);
                }
              }
            }

            for (let i = 0; i < coordinats.length; i += 1) {
              const coordinate = coordinats[i].coordinates.split(',');
              const coordinateX = coordinate[0];
              const coordinateY = coordinate[1];
              const boundsC = new google.maps.LatLngBounds();
              const loc = new google.maps.LatLng(coordinateX, coordinateY);
              boundsC.extend(loc);
              map.fitBounds(boundsC)
              map.setZoom(10);
            }

            coordinats.filter(item => {
              item.info.forEach(info => {
                infoContent.push(info)
              })
            })

            $('.map-holder__aside-inner').html(tooltipTpl(infoContent));
            $('.map-holder__aside').show();

            if (allCoordinats.length > 0) {
              $('.contacts-nav__item').removeClass('active');
              buildMap(coordinats);
            }
          }
        }
        request.send();
      }
    })
  });

  $('.map-holder__close-button').on('click', () => {
    $('.map-holder__aside').hide();
  })

};


// WEBPACK FOOTER //
// app/scripts/components/map.js